module.exports = __webpack_public_path__ + "static/media/iconfont.855423e0.ttf";